
























import { Vue, Prop, Component } from 'vue-property-decorator'

@Component
export default class BaseVipToggle extends Vue {
  @Prop() isVip: boolean

  emitChange () {
    this.$emit('toggleVip', !this.isVip)
  }
}
